import { useParams } from "react-router";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { useSummaryItemReport } from "@/services/backend/htz/summary/hooks/use-summary-item-report";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { MicrobialAssessmentsTable } from "@/services/backend/htz/report/components/microbial-assessments-table";
import { ReportMicrobialAssessmentAddDropdown } from "@/services/backend/htz/report/components/report-microbial-assessment-add-dropdown";

export function MicrobialRoute() {
  const { summaryId, itemId } = useParams();
  const { reportId } = useSummaryItemReport(summaryId!, itemId!);

  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! }, { skip: !reportId });

  if (isLoading) {
    return <CardSkeleton />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!report) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Proben")}</CardTitle>
        <CardDescription>
          {t(
            "Die Proben der Komponenten der Anlage. Die Ergebnisse können manuell eingetragen werden.",
          )}
        </CardDescription>
        <CardAction>
          <ReportMicrobialAssessmentAddDropdown
            report={report}
            disabled={isImmutable(report)}
          />
        </CardAction>
      </CardHeader>
      <CardContent className="space-y-4">
        <MicrobialAssessmentsTable report={report} />
      </CardContent>
    </Card>
  );
}
